import { AxiosResponse } from 'axios';
import fetcher, {
    fetcherFull,
    MethodEnum,
} from 'utils/helpers/browser/newFetcher';
import {
    ApplicationDeleteFileInterface,
    ResponseApiSimple,
    ResponseWithIdSimpleApi,
} from 'submodules/api_middleware';
import {
    StateInterface,
    ValuesStringInterface,
} from 'components/interfaces/GeneralInterface';
import { FormResponseData } from 'services/user.service';
import { getDiscipline } from 'utils/helpers/browser/discipline';
import { getRoute } from 'constants/routes';

export const applicationStateUpdate = async (
    id: number,
    data: ValuesStringInterface,
    generalReason: string
): Promise<ResponseApiSimple> => {
    return await fetcher(
        `/api/application/${id}/state/update`,
        MethodEnum.POST,
        undefined,
        {
            data: {
                fields: data,
                general: generalReason,
            },
        }
    );
};

export const applicationStateResolve = async (
    id: number,
    action: string,
    reason?: string,
    confirm_data?: StateInterface
): Promise<ResponseApiSimple> => {
    return await fetcher(
        `/api/application/${id}/state/resolve`,
        MethodEnum.POST,
        undefined,
        {
            data: { action, reason, confirm_data },
        },
        undefined,
        undefined,
        true
    );
};

export const saveApplicationStateFields = async (
    id: number,
    data: StateInterface
): Promise<FormResponseData> => {
    return await fetcher(
        `/api/application/${id}/state/fields`,
        MethodEnum.POST,
        undefined,
        {
            data,
        }
    );
};

export const saveApplicationStateFile = async (
    id: number,
    document: File,
    fieldName: string
): Promise<ResponseApiSimple | FormResponseData> => {
    if (!document) {
        return saveApplicationStateFields(id, { [fieldName]: null });
    }
    const formData = new FormData();
    formData.append(fieldName, document);
    return await fetcherFull<ResponseApiSimple>(
        `/api/application/${id}/state/file/${fieldName}`,
        MethodEnum.POST,
        null,
        formData
    );
};

export const deleteApplicationStateFiles = async (
    applicationId: number,
    data: ApplicationDeleteFileInterface
): Promise<ResponseApiSimple | FormResponseData> => {
    return await fetcherFull<ResponseApiSimple>(
        `/api/application/${applicationId}/state/file/delete`,
        MethodEnum.DELETE,
        null,
        { data }
    );
};

export const createApplication = async (
    type: string,
    params: { [key: string]: string | number }
): Promise<ResponseWithIdSimpleApi> => {
    return (
        (await fetcher(`/api/application/create`, MethodEnum.POST, undefined, {
            type,
            discipline: getDiscipline(),
            params,
        })) as AxiosResponse<ResponseWithIdSimpleApi>
    ).data;
};

export const createApplicationWithRedirect = async (
    type: string,
    params: { [key: string]: string | number }
): Promise<ResponseWithIdSimpleApi> => {
    const data: ResponseWithIdSimpleApi = await createApplication(type, params);

    if (data?.id) {
        window.pageRedirect(getRoute('/applications/{0}', [data.id]));
        return data;
    }
};
